
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import { murakamiMasanori } from "@src/constants/authors";
import {
  ginzaYouYouFrontImage,
  ginzaYouYouCoffeeImage,
  ginzaYouYouLineImage,
  ginzaYouYouOmuriceImage,
} from "@src/constants/images";
export const meta = {
  path: "/media/ginza/you",
  title: "【平日も大行列】銀座の喫茶youでオムライスのランチを食べてみた",
  description: "東銀座から徒歩3分の距離に位置する老舗の喫茶店「喫茶you」についてご紹介しております。特に、喫茶youの名物「ふわふわオムライス」のランチセット、さらにはいつも大行列ができる行列情報についてご紹介しております。喫茶youに一度でも行きたいと思っている方には筆硯の記事となっております。",
  topImg: ginzaYouYouOmuriceImage,
  author: murakamiMasanori,
  tags: ["銀座", "有名店", "オムライス", "おしゃれな内装", "人気店", "お店の紹介", "1人メシ", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ネオンに輝く「喫茶 you」の看板の前には平日の昼から大行列。ふわふわのオムライスを求めて、若い女性客が多く訪れているのが特徴的です。`}</p>
    <p>{`オムライスの特徴的な風味や、並ばずに入れる狙い目の時間帯はいつなのか、についてご紹介しております。ぜひ、ご一読ください。`}</p>
    <h2>{`喫茶 you とは`}</h2>
    <LazyImage img={ginzaYouYouFrontImage} mdxType="LazyImage" />
    <p>{`東銀座から徒歩 3 分の距離にある同店は、数多くの雑誌への掲載、さらには外国人からの認知度も高い老舗の喫茶店。
遠目から見てもわかるレンガ調の外観とネオンに光るお店の看板が特徴的です。`}</p>
    <p>{`食べログの評価も 3.6 を超え、数多くの方に愛される人気のお店です。`}</p>
    <h3>{`内観はレトロな喫茶店`}</h3>
    <p>{`1 階と 2 階に席を構えており、縦長の間取りの店内は少し窮屈に感じるかもしれない。
2 階は広々としており、赤色のソファーが哀愁を漂わせる雰囲気が喫茶店好きにはたまらないお店になっている。`}</p>
    <h3>{`店員の雰囲気`}</h3>
    <p>{`女子が中心で構成されており、ウェイターといえばという正装で出迎えてくれる。
挨拶や店内への誘導も明るく、印象の良いお店です。`}</p>
    <hr></hr>
    <h2>{`ふわふわのオムライス`}</h2>
    <LazyImage img={ginzaYouYouOmuriceImage} mdxType="LazyImage" />
    <p>{`喫茶 you の名物といえばこちらのオムライス。
大盛りとチーズのトッピングがそれぞれ+100 円ででき、オムライス好きにはたまらない安さになっている。`}</p>
    <h3>{`注文から料理が出てくるまで`}</h3>
    <p>{`注文してから料理が出てくるまで５分以内と早いです。
回転率が早く注文が出てくるのは、忙しいサラリーマンにとっても嬉しいですよね。`}</p>
    <h3>{`オムライスはクリーミーでどっしり`}</h3>
    <p>{`オムライスの味付けはお店によって様々だが、喫茶 you ではクリーミーで濃厚なのが特徴。
バターの風味はもちろんのこと、クリームをふんだんに使った甘味が凝縮されており、甘党のオムライス好きには癖になる味わい。`}</p>
    <p>{`甘いオムライスが苦手な方は少し苦手かもしれないので、普通盛りで食べるのがおすすめです。`}</p>
    <h3>{`ランチはドリンク必須`}</h3>
    <LazyImage img={ginzaYouYouCoffeeImage} mdxType="LazyImage" />
    <p>{`オムライスを単品で頼むことはできず、必ずドリンクを注文するようになっている。
オムライスの値段が 1,000 円で、ドリンクが 300 円程度なので、1,500 円以内で収まるのがお財布に優しいポイントです。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <LazyImage img={ginzaYouYouLineImage} mdxType="LazyImage" />
    <p>{`喫茶 you のオムライスを求めてたくさんの人が平日・休日問わずに来店している。
12 時を過ぎると若者からサラリーマンまで、幅広い方が行列を作っている。`}</p>
    <p>{`雨の日に 11:45 頃に８割の席が埋まっていて、12 時になると席は満席になります。
外は 15 人程度の行列ができていて、待ち時間は 30 分程度。`}</p>
    <p>{`休日になると待ち時間は 2 時間になることもあるので、お店に行く際には早めの時間帯か、遅めの時間帯を狙っていきましょう。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;